import { Component, Host, Prop, h } from '@stencil/core';

@Component({
  tag: 'offer-send',
  styleUrl: 'offer-send.css',
})
export class OfferSend {
  @Prop() hasOffer: boolean = false; // dealer has the offer
  @Prop() whenClicked = () => {};

  hasSentOffer() {
    return this.hasOffer;
  }

  offerSendClick() {
    this.whenClicked();
  }

  render() {
    return (
      <Host>
        {this.hasSentOffer() && (
          <div class="flex items-center alignment-right">
            <div class="mr-1">
              <svg-icon icon="circled-check-mark" class="w-6 h-6" />
            </div>
            <p class="m-0">Offer sent to dealer</p>
          </div>
        )}

        {!this.hasSentOffer() && (
          <ico-button
            buttonStyle="secondary"
            label="Send My Offer To Dealer"
            whenClicked={() => {
              this.offerSendClick();
            }}
          />
        )}
      </Host>
    );
  }
}
